import { render, staticRenderFns } from "./MonitoringDetail.vue?vue&type=template&id=528cd709"
import script from "./MonitoringDetail.vue?vue&type=script&lang=js"
export * from "./MonitoringDetail.vue?vue&type=script&lang=js"
import style0 from "./MonitoringDetail.vue?vue&type=style&index=0&id=528cd709&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports